import AuthManager from "./AuthManager";

class PermissionsManager {
  constructor() {
    this.profileObj = AuthManager.getAuthUser();
  }

  checkIfUserIsAdmin() {
    if (AuthManager.getAuthUser_IsAdmin() == null) {
      var isAdmin = false;
      for (var party of this.profileObj.profile.parties) {
        for (var userType of party.usertypes) {
          for (var role of userType.roles) {
            if (role.name === "DBPromotion_Adminstrator") {
              isAdmin = true;
              break;
            }
          }
          if (isAdmin) break;
        }
        if (isAdmin) break;
      }

      AuthManager.setAuthUser_IsAdmin(isAdmin);
    }
    return AuthManager.getAuthUser_IsAdmin();
  }

  checkIfUserIsAdmin1() {
    if (AuthManager.getAuthUser_IsAdmin() == null) {
      var isAdmin = false;
      isAdmin = this.profileObj?.profile?.parties?.some((party) => {
        return party?.usertypes?.some((userType) => {
          return userType?.roles?.some((role) => {
            return role?.name === "DBPromotion_Adminstrator";
          });
        });
      });
      AuthManager.setAuthUser_IsAdmin(isAdmin);
    }
    return AuthManager.getAuthUser_IsAdmin();
  }

  checkPermission(permissionName) {
    var per = AuthManager.getPermissions();
    if (per[permissionName] !== null && per[permissionName] !== undefined) {
      return per[permissionName];
    }
    return false;
  }

  hasPermission(permissionName, historyobj = null, redirectToiffalse = null) {
    if (this.checkIfUserIsAdmin() === true) {
      return true;
    }
    var res = this.checkPermission(permissionName);
    if (!res && historyobj !== null && historyobj !== undefined) {
      if (redirectToiffalse !== null && redirectToiffalse !== undefined) {
        historyobj.push(redirectToiffalse);
      }
    } else return res;
  }

  ProcessPermissions() {
    var dict = {};
    for (var party of this.profileObj.profile.parties) {
      for (var userType of party.usertypes) {
        for (var role of userType.roles) {
          for (var module of role.modules) {
            for (var permission of module.permissions) {
              var thekey = module.name + "_" + permission.name;
              dict[thekey.toLowerCase()] = true;
            }
          }
        }
      }
    }
    AuthManager.setPermissions(dict);
    this.checkIfUserIsAdmin();
  }

  Check_subscriptions() {
    for (var party of this.profileObj.profile.parties) {
      if (party.subscriptions !== undefined && party.subscriptions !== null) {
        for (var subs of party.subscriptions) {
          return true;
        }
      }
    }
    return this.checkIfUserIsAdmin();
  }

  get_roles() {
    for (var party of this.profileObj.profile.parties) {
      for (var userType of party.usertypes) {
        if (userType.name === "employee") {
          for (var role of userType.roles) {
            return role.name;
          }
        }
      }
    }
  }
}

export default PermissionsManager;
